var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSync = function SvgSync(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.789 6.75H7.5v1.5h-6v-6H3v3.01C5.101 2.468 8.436.75 12 .75 18.203.75 23.25 5.797 23.25 12h-1.5c0-5.376-4.374-9.75-9.75-9.75-3.332 0-6.435 1.734-8.211 4.5m16.422 10.5H16.5v-1.5h6v6H21v-3.01c-2.102 2.791-5.436 4.51-9 4.51C5.797 23.25.75 18.203.75 12h1.5c0 5.377 4.374 9.75 9.75 9.75 3.332 0 6.435-1.734 8.211-4.5",
    clipRule: "evenodd"
  })));
};
export default SvgSync;